import React, { useEffect, useState } from 'react'
import { Icon, Typography } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'

import { ApplicationState } from 'src/store'
import { ColumnProps } from 'src/components/Ant/Table'
import { getIntegrationCredentials } from 'src/store/ducks/integrations/actions'
import { IntegrationCredential } from 'src/store/ducks/integrations/types'
import { Table as AntTable } from 'src/components/Ant'
import { Text } from 'src/components/atoms'

import ModalConfirmPassword from '../modal-password-confirmation'

function Table(): JSX.Element {
  const {
    integrations: { error, list, loading }
  } = useSelector((state: ApplicationState) => ({
    integrations: state.integrations
  }))
  const dispatch = useDispatch()

  const [modalPasswordConfirmation, setModalPasswordConfirmation] = useState<
    boolean
  >(false)
  const [username, setUsername] = useState<string>('')

  useEffect(() => {
    dispatch(getIntegrationCredentials())
  }, [dispatch])

  function confirmPasswordToggle() {
    setModalPasswordConfirmation(value => !value)
  }

  const columns: ColumnProps<IntegrationCredential>[] = [
    {
      align: 'center',
      dataIndex: 'organization',
      key: 'organization',
      render: (value: string) => <Text>{value}</Text>,
      title: 'web.integration.table.column.organization'
    },
    {
      dataIndex: 'bearer',
      key: 'bearer',
      render: (value: string, register: IntegrationCredential) => {
        const title = `Login: ${register.login}\n${value}`
        return (
          <span title={title}>
            <Text copyable={{ text: value }}>
              {value.substring(0, 40)}
              ...
            </Text>
          </span>
        )
      },
      title: 'web.integration.table.column.bearer'
    },
    {
      dataIndex: 'expire',
      key: 'expire',
      render: (value: number) => (
        <Text>{moment.unix(value).format('DD/MM/YYYY')}</Text>
      ),
      title: 'web.integration.table.column.expire',
      width: 120
    },
    {
      align: 'center',
      key: 'actions',
      render: (_: unknown, register: IntegrationCredential) => (
        <Icon
          type="sync"
          onClick={() => {
            setUsername(register.login)
            setModalPasswordConfirmation(value => !value)
          }}
        />
      ),
      title: 'web.integration.table.column.action'
    }
  ]

  if (error) {
    return (
      <div style={{ textAlign: 'center' }}>
        <Icon style={{ marginRight: '4px' }} type="stop" />
        <Typography.Text>{error}</Typography.Text>
      </div>
    )
  }
  return (
    <>
      <AntTable
        className="table-striped"
        columns={columns}
        dataSource={list}
        loading={loading}
        pagination={false}
      />
      <ModalConfirmPassword
        toggle={confirmPasswordToggle}
        username={username}
        visible={modalPasswordConfirmation}
      />
    </>
  )
}

export default Table
